var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M31 16.691l-2.013 1.84c-.683.625-1.791.625-2.474 0a1.505 1.505 0 010-2.262l5.25-4.8c.683-.625 1.791-.625 2.474 0l5.25 4.8a1.505 1.505 0 010 2.262c-.683.625-1.791.625-2.474 0L35 16.691v19.603c0 .942-.895 1.706-2 1.706s-2-.764-2-1.706V16.691zM14 32.31V12.706c0-.942.895-1.706 2-1.706s2 .764 2 1.706v19.603l2.013-1.84c.683-.625 1.791-.625 2.474 0a1.505 1.505 0 010 2.262l-5.25 4.8c-.683.625-1.791.625-2.474 0l-5.25-4.8a1.505 1.505 0 010-2.262c.683-.625 1.791-.625 2.474 0L14 32.309z",
    id: "sort_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sort_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sort_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#sort_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#sort_svg__b)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PHBhdGggZD0iTTMxIDE2LjY5MWwtMi4wMTMgMS44NGMtLjY4My42MjUtMS43OTEuNjI1LTIuNDc0IDBhMS41MDUgMS41MDUgMCAwIDEgMC0yLjI2Mmw1LjI1LTQuOGMuNjgzLS42MjUgMS43OTEtLjYyNSAyLjQ3NCAwbDUuMjUgNC44YTEuNTA1IDEuNTA1IDAgMCAxIDAgMi4yNjJjLS42ODMuNjI1LTEuNzkxLjYyNS0yLjQ3NCAwTDM1IDE2LjY5MXYxOS42MDNjMCAuOTQyLS44OTUgMS43MDYtMiAxLjcwNnMtMi0uNzY0LTItMS43MDZWMTYuNjkxek0xNCAzMi4zMVYxMi43MDZjMC0uOTQyLjg5NS0xLjcwNiAyLTEuNzA2czIgLjc2NCAyIDEuNzA2djE5LjYwM2wyLjAxMy0xLjg0Yy42ODMtLjYyNSAxLjc5MS0uNjI1IDIuNDc0IDBhMS41MDUgMS41MDUgMCAwIDEgMCAyLjI2MmwtNS4yNSA0LjhjLS42ODMuNjI1LTEuNzkxLjYyNS0yLjQ3NCAwbC01LjI1LTQuOGExLjUwNSAxLjUwNSAwIDAgMSAwLTIuMjYyYy42ODMtLjYyNSAxLjc5MS0uNjI1IDIuNDc0IDBMMTQgMzIuMzA5eiIgaWQ9ImEiLz48L2RlZnM+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+PHVzZSB4bGluazpocmVmPSIjYSIvPjwvbWFzaz48dXNlIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJub256ZXJvIiB4bGluazpocmVmPSIjYSIvPjxnIG1hc2s9InVybCgjYikiIGZpbGw9ImN1cnJlbnRDb2xvciI+PHBhdGggZD0iTTAgMGg0OHY0OEgweiIvPjwvZz48L2c+PC9zdmc+";
export { SvgSort as ReactComponent };